import React, { useContext } from "react";
import { FilterPanelContext } from "context/providers/FilterPanelProvider";
import { cn } from "utils";

const ExpandCollapseAllControl = ({ className }) => {
  const context = useContext(FilterPanelContext);

  if (!context) {
    return null;
  }

  const { allExpanded, toggleExpandCollapseAll } = context;

  return (
    <button
      type="button"
      onClick={toggleExpandCollapseAll}
      className={cn("filter-sidebar-btn", className)}
    >
      {allExpanded ? "Collapse All" : "Expand All"}
    </button>
  );
};

export default ExpandCollapseAllControl;
